module.exports = "/assets/data/a97b6b1182d3125739fee5fef61e001a-HR6.data.json";